import React, { Suspense, lazy } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { FallbackView } from '../../_metronic/partials'

export function SalesPOSRoutes() {
  const CashierPOSWrapper = lazy(() => import('../pages/order/cashier-pos/CashierPOS'))

  const normalRoutes = [
    { path: '/cashier-pos', component: CashierPOSWrapper },
  ];
  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        {normalRoutes.map((route) => (
          <Route exact key={route.path} path={route.path} component={route.component} />
        ))}
        <Redirect from='/' to='/cashier-pos' />
      </Switch>
    </Suspense>
  );
}
